import { useFirestoreGeneral} from '../../firebase/useFirestore';
import { useEffect, useState } from 'react';

const OutputsCount = ({activityId}) => {
 // State
    const [counter, setCounter] = useState(0);

    // Firestore
    const outputs = useFirestoreGeneral('Outputs', 'ActivityID', activityId || '');

    // Update counter (exclude soft-deleted outputs — ADR-008)
    useEffect(() => {
          setCounter((outputs || []).filter((o) => !o.Deleted).length);
    }, [outputs])

  return (
    <>
        {counter}
    </>
    
  )
}

export default OutputsCount